// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"2af3e980","787":"aadca95f"}[chunkId] + ".chunk.js";
};